import { Heading, TextBodyArticle } from "backpack-ui/dist/components/text";
import * as cn from "classnames";
import * as React from "react";
var NoResults = function (_a) {
    var keyword = _a.keyword, className = _a.className;
    return (React.createElement("div", { className: cn(className) },
        React.createElement(Heading, { level: 4, size: 4 },
            "No results found",
            keyword ? " for \u2019" + keyword + "\u2019" : "",
            "."),
        React.createElement(TextBodyArticle, { style: { marginTop: "24px" } },
            "Is this something we should have on our site? ",
            React.createElement("a", { href: "https://www.lonelyplanet.com/contact" }, "Let us know"),
            ".")));
};
export default NoResults;



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/noResults/index.tsx
// module id = +nco
// module chunks = 2